/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const TasksDashboardLoadable = loadable(() => import('./TasksDashboard'), { fallback: <LoadingIndicator /> });

export const TasksListLoadable = loadable(() => import('./TasksList'), { fallback: <LoadingIndicator /> });
